import GenerateMorePopover from 'trunks/controllers/admin/settings/nav.js'
import SettingsNavigator from 'trunks/vue/admin/compositions/settings_sidebar/settings_navigator.js'
import SettingsBrandImages from 'trunks/vue/admin/components/settings/settings_container/settings_brand_images.js'

class Admin__Settings__BrandImagesPreferencesController extends Skylark.App.BaseController {
  show() {
    this._generateSettingsSidebarView('settings__brand_images_preferences')
    Skylark.Libs.Ajax.get('/admin/settings/brand_images_preferences.json', {
      responseType: 'json',
      success: (data) => {
        new SettingsBrandImages({
          el: DomMaster.find('#js-settings-brand_images_preferences').node,
          propsData: {
            activeTab: 'brand_images_preferences',
            brandImagesData: data
          }
        })
      }
    })
  }
}

Admin__Settings__BrandImagesPreferencesController.include(GenerateMorePopover, SettingsNavigator)

export default Admin__Settings__BrandImagesPreferencesController
